import type { ShopifyAppConfig } from "../ShopifyConnectionConfig";
import { getShopifyModelApiIdentifierByModelKey } from "./apiIdentifiers";
import type { ShopifyConnectionMetadataObject } from "./file-based-actions/shopifyConnectionMetadataSchema";
import { ShopifyShopKey } from "./keys";
import { ShopifyBaseConfig } from "./ShopifyBaseConfig";
import { defaultRequiredScopesForVersion, normalizeScopes } from "./utils";

/**
 * See packages/state-trees/src/connections/ShopifyConnectionConfig.ts for documentation
 * on the different types of Shopify configurations
 */
export const ShopifyBaseAdminConnectionConfig = <Name extends string, T extends typeof ShopifyAppConfig>(name: Name, AppConfig: T) =>
  ShopifyBaseConfig(name, AppConfig)
    .views((self) => ({
      get requestedScopes() {
        return defaultRequiredScopesForVersion(self.enabledModelKeys, self.shopifyApiVersion);
      },
      get requestedScopesAsArray() {
        return this.requestedScopes;
      },
      get normalizedScopes() {
        return normalizeScopes(this.requestedScopesAsArray);
      },
      get hasProtectedAccessScopes() {
        return false;
      },
    }))
    .views((self) => ({
      get metadataObject(): ShopifyConnectionMetadataObject {
        return {
          apiVersion: self.baseMetadataObject.apiVersion,
          enabledModels: self.baseMetadataObject.enabledModels.filter(
            (model) => model !== getShopifyModelApiIdentifierByModelKey(ShopifyShopKey)
          ),
          type: "admin",
        };
      },
    }));
